<article
  *ngIf="viewModel$ | async as viewModel"
  class="location-item"
  [class.active]="isActive"
  (click)="onLocationClick()"
>
  <div class="location-view">
    <i [class]="icon" class="location-icon"></i>

    <div class="location-details">
      <div class="location-primary-details">
        <span class="location-type">
          {{ formattedLocationType | titlecase }}
        </span>
        <span class="location-fields" *ngIf="viewModel.fields">{{
          viewModel.fields
        }}</span>
      </div>
      <span class="location-address">
        <span
          class="freya-link-button"
          pTooltip="Open in Google Maps"
          (click)="
            $event.stopPropagation();
            store.dispatch(
              actions.addressLinkClicked({
                locationType: locationType,
              })
            )
          "
        >
          {{ viewModel.address }}
        </span>
      </span>
      <div class="access-notes" *ngIf="viewModel.accessNotes">
        {{ viewModel.accessNotes }}
      </div>
    </div>
  </div>
</article>
